import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/faqs';
import { siteInfo } from '@/mocks/categories';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="关于瓜田笔记，你可能想问"
            desc="从内容来源到投稿方式，这里整理了几个被问得最多的问题。还有疑问可以发邮件给我们。"
          />
          <a
            href={`mailto:${siteInfo.email}`}
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-mail-send-line" />
            继续提问
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left transition-colors"
                    aria-expanded={isOpen}
                  >
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.q}</h3>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                        isOpen
                          ? 'border-primary-500 bg-primary-500 text-background-50'
                          : 'border-background-300 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}